<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>人均通关时间(上一次过关时间-这次过关时间)(流水时间)/过了这关的人数</span>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
          >
            <template scope="scope">
              {{ dateStrTodate(scope.row.date) }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in levelData"
            :key="index"
            :label="'等级'+item"
            align="center"
          >
            <el-table-column
              label="通关人数"
              align="center"
            >
              <template scope="scope">
                {{ scope.row.user[item] }}
              </template>
            </el-table-column>
            <el-table-column
              label="人均分钟"
              align="center"
            >
              <template scope="scope">
                {{ scope.row.time[item] }}
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-card>

      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="24" :xl="24" :lg="24" :style="{ marginBottom: '12px' }">
          <upLevelAvg ref="dayCount" />
        </el-col>
        <el-col :sm="24" :xs="24" :md="24" :xl="24" :lg="24" :style="{ marginBottom: '12px' }">
          <upLevelAvg ref="dayTime" :typ="'time'" />
        </el-col>
      </el-row>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserUpLevelTimeStat } from '@/api/user/user_info'
import upLevelAvg from '@/views/config/up-level-stat/components/uplevel-level-time-user-stat'
import upLevelCountAvg from '@/views/config/up-level-stat/components/uplevel-level-num-stat.vue'
import { getLastDates, dateStrTodate, scientificFormat, getCacheQuery, setCacheQuery } from '@/utils'
export default {
  name: 'UpLevelTimeStat',
  components: {
    upLevelAvg,
    upLevelCountAvg
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      },
      ridData: {},
      tableData: [],
      levelData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(1)
    }

    this.getTables()
  },
  methods: {
    dateStrTodate,
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables({})
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables(event) {
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getUserUpLevelTimeStat(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        if (res.code === 200) {
          this.tableData = res.data.data
          if (this.tableData.length > 0) {
            this.levelData = []
            for (let i = 2; i <= res.data.level; i++) {
              this.levelData.push(i)
            }
            this.$refs.dayCount.refresh(this.tableData)
            this.$refs.dayTime.refresh(this.tableData)
          }
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
